import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Stack, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import NurseFormHeader from './nurseFormHeader';
import NurseFamilyView from './nurseFamilyView';
import NursePersonalnfo from './nursePersonalnfo';
import NurseContact from './contact';
import NurseDocumentView from './nurseDocument';
import NurseSalaryPaymentList from '../nurse-salary-payments/nurseSalaryPaymentList';
import NurseSalaryPaymentForm from '../nurse-salary-payments/nursePaymentForm';
import NurseAdvancePaymentList from '../nurse-advance-payments/nurseAdvancePayList';
import NurseAdvancePaymentForm from '../nurse-advance-payments/nurseAdvancePayForm';
import NurseVacationList from '../nurse-vacation-trackers/nurseVacationList';
import ProfilePhotoCard from '../shared/components/profilePhoto';
import DocumentForm from '../shared/components/documentForm';
import ConfirmDialog from '../shared/components/confirmDialog';
import { NurseAPIUrl, DownloadDocumentAPIUrl } from '../utils/extensions/functionEx';
import { HomeContext } from '../utils/contexts/homeContext';
import { NurseFormContext } from '../utils/contexts/nurseFormContext';
import { ConstantValues, FormMode } from '../utils/extensions/constantEx'
import { NewNurseFormInitalState, SelectedNurseJsonInitalState, AddressFormInitalState } from '../utils//hooks/useNurseForm';
import { GetDayJSValueFromUTCDate, GetDateFromDayJSValue, GetNoToCurrencyFormat } from '../utils/extensions/functionEx';
import PageLoading from '../shared/components/backdrop';
import { useCookies } from 'react-cookie';

const NurseForm = (props) => {
    const { formMode, selectedNurseId } = props;
    const { ShowAPIError, OpenErrorAlert, OpenSuccessAlert, homeState, ClearLoggedUser } = useContext(HomeContext);
    const { nurseFormValue, selectedNurseJosn, SetSelectedNurseJson, SetNurseFormValue } = useContext(NurseFormContext);

    const location = useLocation();
    const navigate = useNavigate();

    const [isOpenPageLoad, setIsOpenPageLoad] = useState(false);
    const [formOpenMode, setFormOpenMode] = useState(formMode ?? FormMode.NewMode);
    const [expanded, setExpanded] = useState('panelPersonalInfo');
    const [cleared, setCleared] = useState(false);
    const [isShowValidationMsgs, setIsShowValidationMsgs] = useState(false);
    const [isOpenEditProfilePhoto, setIsOpenEditProfilePhoto] = React.useState(false);
    const [isOpenProfilePhotoDeleteConfirm, setiIsOpenProfilePhotoDeleteConfirm] = React.useState(false);
    const [nurseName, setNurseName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [phone1, setPhone1] = useState('');
    const [phone2, setPhone2] = useState('');
    const [whatsAppNo, setwhatsAppNo] = useState('');
    const [isOnLeave, setIsOnLeave] = useState(false);
    const [rejoinDate, setRejoinDate] = useState(null);
    const [advanceAmount, setAdvanceAmount] = useState('0.00');
    const [profilePhotoFile, setProfilePhotoFile] = React.useState(null);
    const [profilePhotoUrl, setProfilePhotoUrl] = React.useState(null);
    const [removedNurseDocIds, setRemovedNurseDocIds] = useState([]);
    const [removedDocIds, setRemovedDocIds] = useState([]);
    const [isOpenNewSalaryPayment, setIsOpenNewSalaryPayment] = useState(false);
    const [selectedNurseSalaryPayment, setSelectedNurseSalaryPayment] = useState(null);
    const [isOpenAdvancePaymentForm, setIsOpenAdvancePaymentForm] = useState(false);
    const [selectedAdvancePayment, setSelectedAdvancePayment] = useState(null);
    const [statusText, setStatusText] = useState('');
    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    useEffect(() => {
        setFormMode(formMode ?? FormMode.NewMode);
        if (selectedNurseId > 0) {
            getNurse(selectedNurseId);
        }
    }, [selectedNurseId, formMode]);

    const setFormMode = (tempFrmMode) => {
        clearForm();
        setFormOpenMode(tempFrmMode);
        SetSelectedNurseJson({ ...SelectedNurseJsonInitalState });
        SetNurseFormValue({ ...NewNurseFormInitalState });
    }

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    useEffect(() => {
        if (formOpenMode === FormMode.None) {
            setFormOpenMode(FormMode.NewMode);
        }
    }, [formOpenMode]);


    const handleAccordionChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    }

    const handleOpenProfilePhotoEditClick = () => {
        setIsOpenEditProfilePhoto(true);
    }

    const handleOpenProfilePhotoDeleteClick = () => {
        setiIsOpenProfilePhotoDeleteConfirm(true);
    }

    const handleProfilePhotoSaveClick = (profileDocument) => {
        if (profilePhotoFile) {
            setRemovedDocIds([...removedDocIds, profilePhotoFile.uploadedFileId]);
        }
        setProfilePhotoFile(profileDocument);
        setProfilePhotoUrl(null);
        setIsOpenEditProfilePhoto(false);
    }

    const handleProfilePhotoCancelClick = () => {
        setIsOpenEditProfilePhoto(false);
    }

    const handleProfilePhotoDeleteConfirmOKClick = () => {
        if (profilePhotoFile) {
            setRemovedDocIds([...removedDocIds, profilePhotoFile.uploadedFileId]);
        }
        setProfilePhotoFile(null);
        setProfilePhotoUrl(null);
        setiIsOpenProfilePhotoDeleteConfirm(false);
    }

    const handleProfilePhotoDeleteConfirmCancelClick = () => {
        setiIsOpenProfilePhotoDeleteConfirm(false);
    }

    const getNurse = async (nurseId) => {
        try {
            let tempNurseJson = null;
            setIsOpenPageLoad(true);

            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(NurseAPIUrl(homeState.loggedUser.companyCode, nurseId), {
                method: "GET",
                headers: headers
            });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                tempNurseJson = await response.json();
            } else {
                ShowAPIError(response);
            }

            if (tempNurseJson) {
                const tempNurse = {
                    id: tempNurseJson.id,
                    code: tempNurseJson.code,
                    dob: GetDayJSValueFromUTCDate(tempNurseJson.dob),
                    genderId: tempNurseJson.gender,
                    spouseName: tempNurseJson.spouse_name,
                    fatherName: tempNurseJson.father_name,
                    motherName: tempNurseJson.mother_name,
                    address1: tempNurseJson.address1,
                    address2: tempNurseJson.address2,
                    policeStation: tempNurseJson.police_station,
                    education: tempNurseJson.education,
                    languagesKnown: tempNurseJson.languages_known,
                    height: tempNurseJson.height,
                    colour: tempNurseJson.colour,
                    religionId: tempNurseJson.religion_id,
                    bankAccount: tempNurseJson.bank_account,
                    notes: tempNurseJson.notes,
                    aadhaarDocument: null,
                    aadhaarNo: '',
                    relatives: [],
                    contacts: [],
                    documents: [],
                    removed_nurse_doc_ids: [],
                    removed_doc_ids: [],
                };
                for (const tempFamily of tempNurseJson.relatives) {
                    const tempDbFamily = {
                        id: tempFamily.id,
                        name: tempFamily.relative_name,
                        relation: tempFamily.relationship,
                        phoneNo: tempFamily.phone_no
                    };
                    tempNurse.relatives.push({ ...tempDbFamily });
                }
                for (const tempContact of tempNurse.contacts) {
                    const tempAddress = { ...AddressFormInitalState };
                    if (tempContact.address && tempContact.address.id && tempContact.address.id > 0) {
                        tempAddress.id = tempContact.address.id;
                        tempAddress.address = tempContact.address.address;
                    }
                    const tempDbContact = {
                        id: tempContact.id,
                        name: tempContact.contact_name,
                        address: tempAddress,
                        phoneNo1: tempContact.phone1,
                        phoneNo2: tempContact.phone2
                    };
                    tempNurse.contacts.push(tempDbContact);
                }
                SetSelectedNurseJson({ ...tempNurseJson });
                SetNurseFormValue({ ...tempNurse });

                setNurseName(tempNurseJson.nurse_name);
                setMobileNo(tempNurseJson.phone1);
                setPhone1(tempNurseJson.phone2);
                setPhone2(tempNurseJson.phone3);
                setwhatsAppNo(tempNurseJson.whatsapp_no);
                setAdvanceAmount(GetNoToCurrencyFormat(tempNurseJson.advance_amount ?? 0));

                // const tempRejoinDate = GetDayJSValueFromUTCDate(tempNurseJson.rejoin_date);
                // if (tempRejoinDate.year() > 2000) {
                //     setIsOnLeave(true);
                //     setRejoinDate(tempRejoinDate);
                // }

                setStatusText(tempNurseJson.is_service_found ? 'In Service' : (tempNurseJson.is_vacation_found ? 'On Leave' : 'Not in Service'));

                await getProfilePhotoFromDB(tempNurseJson.photo_id);
            }
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            handlePageLoadingClose();
        }
    }

    const getProfilePhotoFromDB = async (db_photo_id) => {
        if (db_photo_id && db_photo_id > 0) {
            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(DownloadDocumentAPIUrl(homeState.loggedUser.companyCode, db_photo_id), {
                method: "GET",
                headers: headers
            });

            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                const blob = await response.blob();
                const imageObjectUrl = URL.createObjectURL(blob);
                setProfilePhotoFile({ uploadedFileId: db_photo_id });
                setProfilePhotoUrl(imageObjectUrl);
            } else {
                ShowAPIError(response);
            }
        }
    }

    const handleSaveClick = async () => {
        try {
            let tempNurseId = 0;
            if (!isFormValid()) {
                setIsShowValidationMsgs(true);
                return;
            }
            setIsOpenPageLoad(true);

            if (formOpenMode === FormMode.NewMode) {
                tempNurseId = await addNewNurseAPI();
            } else if (formOpenMode === FormMode.EditMode) {
                tempNurseId = await updateNurseAPI();
            }

            if (tempNurseId > 0) {
                clearForm();
                setFormMode(FormMode.ViewMode);
                await getNurse(tempNurseId);
            }
        }
        catch (error) {
            OpenErrorAlert(error);
        }
        finally {
            handlePageLoadingClose();
        }
    }

    const isFormValid = () => {
        const tempNurse = { ...nurseFormValue };

        if (nurseName.trim().length === 0 || mobileNo.trim().length === 0 || !tempNurse.dob || parseInt(tempNurse.genderId ?? 0) < 0 || parseInt(tempNurse.religionId ?? 0) <= 0
            || !tempNurse.address1 || !tempNurse.address1.address || tempNurse.address1.address.trim().length === 0 || !tempNurse.address1.district || tempNurse.address1.district.trim().length === 0
            || (isOnLeave && !rejoinDate)) {
            return false;
        }
        return true;
    }

    const getNurseFormValues = () => {
        const tempNurse = { ...nurseFormValue };
        const requestFormValue = {
            id: 0,
            photo_id: 0,
            aadhaar_doc_id: 0,
            relatives: [],
            contacts: [],
            documents: []
        };
        let tempHeight = !tempNurse.height || isNaN(tempNurse.height) ? 0 : parseFloat(tempNurse.height);
        tempHeight = tempHeight > 0 ? tempHeight : 0;

        requestFormValue.nurse_name = nurseName.trim();
        requestFormValue.phone1 = mobileNo.trim();
        requestFormValue.phone2 = phone1.trim();
        requestFormValue.phone3 = phone2.trim();
        requestFormValue.whatsapp_no = whatsAppNo.trim();
        requestFormValue.rejoin_date = ConstantValues.DefaultDateValue;

        requestFormValue.id = tempNurse.id;
        requestFormValue.dob = GetDateFromDayJSValue(tempNurse.dob);
        requestFormValue.gender_id = tempNurse.genderId;
        requestFormValue.spouse_name = tempNurse.spouseName;
        requestFormValue.father_name = tempNurse.fatherName;
        requestFormValue.mother_name = tempNurse.motherName;
        requestFormValue.address1 = tempNurse.address1;
        requestFormValue.address2 = tempNurse.address2;
        requestFormValue.police_station = tempNurse.policeStation;
        requestFormValue.education = tempNurse.education;
        requestFormValue.languages_known = tempNurse.languagesKnown;
        requestFormValue.height = tempHeight.toString();
        requestFormValue.colour = tempNurse.colour;
        requestFormValue.religion_id = tempNurse.religionId;
        requestFormValue.bank_account = tempNurse.bankAccount;
        requestFormValue.notes = tempNurse.notes;

        requestFormValue.photo_id = 0;
        if (profilePhotoFile && profilePhotoFile.uploadedFileId && profilePhotoFile.uploadedFileId > 0) {
            requestFormValue.photo_id = profilePhotoFile.uploadedFileId;
        }
        requestFormValue.removed_nurse_doc_ids = [...removedNurseDocIds, ...tempNurse.removed_nurse_doc_ids];
        requestFormValue.removed_doc_ids = [...removedDocIds, ...tempNurse.removed_doc_ids];

        for (const tempFamily of tempNurse.relatives) {
            const tempDbFamily = {
                id: tempFamily.id,
                relative_name: tempFamily.name,
                relationship: tempFamily.relation,
                phone_no: tempFamily.phoneNo
            };
            requestFormValue.relatives.push({ ...tempDbFamily });
        }

        for (const tempContact of tempNurse.contacts) {
            const tempDbContact = {
                id: tempContact.id,
                contact_name: tempContact.name,
                address: tempContact.address,
                phone1: tempContact.phoneNo1,
                phone2: tempContact.phoneNo2
            };
            requestFormValue.contacts.push(tempDbContact);
        }
        for (const tempDoc of tempNurse.documents.filter(col => col.id < 0)) {
            const tempDbDoc = {
                id: tempDoc.id,
                document_id: tempDoc.uploadedFileId,
                document_type: tempDoc.documentType,
                document_no: tempDoc.docNo,
                notes: tempDoc.notes
            };
            requestFormValue.documents.push(tempDbDoc);
        }
        return { ...requestFormValue };
    }

    const addNewNurseAPI = async () => {
        try {
            const tempNurse = getNurseFormValues();
            tempNurse.id = 0;

            const headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Accept-Encoding", "application/json");
            headers.append("Content-Type", "application/json");
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);

            const response = await fetch(NurseAPIUrl(homeState.loggedUser.companyCode), {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tempNurse)
            });

            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 201) {
                OpenSuccessAlert('New nurse added successfully.');

                const tempJsonNurse = await response.json();
                return tempJsonNurse.id;
            }
            ShowAPIError(response);
            return -1;
        }
        catch (error) {
            OpenErrorAlert(error)
            return -1;
        }
    }

    const updateNurseAPI = async () => {
        try {
            const tempNurse = getNurseFormValues();

            const headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Accept-Encoding", "application/json");
            headers.append("Content-Type", "application/json");
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);

            const response = await fetch(NurseAPIUrl(homeState.loggedUser.companyCode), {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tempNurse)
            });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                OpenSuccessAlert('Nurse details successfully updated.');

                const tempJsonNurse = await response.json();
                return tempJsonNurse.id;
            }
            ShowAPIError(response);
            return -1;
        }
        catch (error) {
            OpenErrorAlert(error)
            return -1;
        }
    }

    const clearForm = () => {
        setNurseName('');
        setMobileNo('');
        setPhone1('');
        setPhone2('');
        setwhatsAppNo('');
        setIsOnLeave(false);
        setRejoinDate(null);
        setAdvanceAmount('0.00');
        setProfilePhotoFile(null);
        setProfilePhotoUrl(null);
        SetSelectedNurseJson(null);
        setRemovedNurseDocIds([]);
        setRemovedDocIds([]);
        SetNurseFormValue(null);
        setExpanded('panelPersonalInfo');
        setIsShowValidationMsgs(false);
        setStatusText('')
    }

    const handleEditClick = async () => {
        const tempNurse = { ...selectedNurseJosn };
        setFormMode(FormMode.EditMode);
        await getNurse(tempNurse.id);
    }

    const handleCancelClick = async () => {
        if (formOpenMode === FormMode.ViewMode) {
            backToNurseSearch();
            return;
        }
        const tempNurse = { ...nurseFormValue };
        if (formOpenMode === FormMode.EditMode && tempNurse && tempNurse && tempNurse.id > 0) {
            clearForm();
            setFormMode(FormMode.ViewMode);
            await getNurse(tempNurse.id);
        }
        else {
            clearForm();
            setFormMode(FormMode.None);
        }
    }

    const handlePageLoadingOpen = () => {
        setIsOpenPageLoad(true);
    }

    const handlePageLoadingClose = () => {
        setIsOpenPageLoad(false);
    }

    const backToNurseSearch = () => {
        if (location && location.state && location.state.from && location.state.from === 'nurse-search') {
            navigate("/search-nurses", {
                replace: false
            });
        }
    }

    const handleOpenNewSalaryPaymentClick = (selectedPayment) => {
        setIsOpenNewSalaryPayment(true);
        setSelectedNurseSalaryPayment(selectedPayment);
    }

    const handleCloseNewSalaryPaymentClick = () => {
        setIsOpenNewSalaryPayment(false);
        setSelectedNurseSalaryPayment(null);
    }

    const handleOpenAdvancePaymentClick = (selectedPayment) => {
        setIsOpenAdvancePaymentForm(true);
        setSelectedAdvancePayment(selectedPayment);
    }

    const handleCloseAdvancePaymentClick = () => {
        setIsOpenAdvancePaymentForm(false);
        setSelectedAdvancePayment(null);
    }

    return (
        <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-in"}>

                <Stack spacing={0}>
                    {
                        isOpenPageLoad &&
                        <PageLoading isOpenPageLoading={isOpenPageLoad} handleClose={handlePageLoadingClose} />
                    }
                    <NurseFormHeader formMode={formOpenMode} handleEditClick={handleEditClick} handleOpenNewSalaryPaymentClick={() => handleOpenNewSalaryPaymentClick(null)}
                        handleSaveClick={handleSaveClick} handleOpenAdvancePaymentClick={() => handleOpenAdvancePaymentClick(null)}
                        handleCancelClick={handleCancelClick} />
                    <Box sx={{ padding: "16px", maxHeight: '80vh', overflowY: 'auto' }}>
                        <Stack>
                            <Box>
                                <Grid container spacing={1}>
                                    <Grid size={8}>
                                        <Grid container spacing={2}>
                                            <Grid size={3}>
                                                <TextField size="small" fullWidth
                                                    label="File No"
                                                    helperText=""
                                                    value={nurseFormValue && nurseFormValue.code ? nurseFormValue.code : '0'}
                                                    slotProps={{
                                                        input: {
                                                            readOnly: true,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size={9}>
                                                <TextField size="small" fullWidth required
                                                    label="Name"
                                                    error={isShowValidationMsgs && nurseName.trim().length === 0 ? true : false}
                                                    helperText={isShowValidationMsgs && nurseName.trim().length === 0 ? 'Enter nurse name' : ''}
                                                    value={nurseName}
                                                    onChange={(event) => {
                                                        setNurseName(event.target.value);
                                                        setIsShowValidationMsgs(false);
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            readOnly: formOpenMode === FormMode.ViewMode
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size={3}>
                                                <TextField size="small" fullWidth required
                                                    label="Mobile No"
                                                    error={isShowValidationMsgs && mobileNo.trim().length === 0 ? true : false}
                                                    helperText={isShowValidationMsgs && mobileNo.trim().length === 0 ? 'Enter mobile no' : ''}
                                                    value={mobileNo}
                                                    onChange={(event) => {
                                                        setMobileNo(event.target.value);
                                                        setIsShowValidationMsgs(false);
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            readOnly: formOpenMode === FormMode.ViewMode
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            {/* <Grid size={3}>
                                                <TextField size="small" fullWidth
                                                    label="Whats App No"
                                                    value={whatsAppNo}
                                                    onChange={(event) => setwhatsAppNo(event.target.value)}
                                                    slotProps={{
                                                        input: {
                                                            readOnly: formOpenMode === FormMode.ViewMode
                                                        },
                                                    }}
                                                />
                                            </Grid> */}
                                            <Grid size={3}>
                                                <TextField size="small" fullWidth
                                                    label="Phone 1"
                                                    value={phone1}
                                                    onChange={(event) =>
                                                        setPhone1(event.target.value)
                                                    }
                                                    slotProps={{
                                                        input: {
                                                            readOnly: formOpenMode === FormMode.ViewMode
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid size={3}>
                                                <TextField size="small" fullWidth
                                                    label="Phone 2"
                                                    value={phone2}
                                                    onChange={(event) => setPhone2(event.target.value)}
                                                    slotProps={{
                                                        input: {
                                                            readOnly: formOpenMode === FormMode.ViewMode
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            {
                                                formOpenMode !== FormMode.NewMode &&
                                                <Grid size={3}>
                                                    <TextField size="small" fullWidth
                                                        label="Advance Amount"
                                                        type="number"
                                                        value={advanceAmount}
                                                        slotProps={{
                                                            input: {
                                                                readOnly: true
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            }

                                            {/* {
                                                formOpenMode !== FormMode.NewMode &&
                                                <Grid size={8}>
                                                    <Stack direction="row" spacing={2}>
                                                        <FormGroup>
                                                            <FormControlLabel sx={{ width: 110 }} disabled={formOpenMode === FormMode.ViewMode}
                                                                control={<Checkbox checked={isOnLeave}
                                                                    onChange={(event) => {
                                                                        setIsOnLeave(event.target.checked);
                                                                    }} />}
                                                                size="small" label="On Leave" />
                                                        </FormGroup>
                                                        <DatePicker format="DD/MM/YYYY"
                                                            label="Rejoin Date" readOnly={!isOnLeave}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small", fullWidth: true, required: { isOnLeave },
                                                                    error: isShowValidationMsgs && isOnLeave && !rejoinDate ? true : false,
                                                                    helperText: isShowValidationMsgs && isOnLeave && !rejoinDate ? 'Enter next rejoin date' : ''
                                                                },
                                                                field: {
                                                                    clearable: true,
                                                                    onClear: () => setCleared(true)
                                                                }
                                                            }}
                                                            value={rejoinDate} minDate={dayjs().add(-10, 'day')}
                                                            onChange={(newValue) => setRejoinDate(newValue)}
                                                        />
                                                    </Stack>
                                                </Grid>
                                            }
                                            {
                                                formOpenMode !== FormMode.NewMode &&
                                                <Grid size={4}>
                                                    <TextField size="small" fullWidth
                                                        label="Advance Amount"
                                                        type="number"
                                                        value={advanceAmount}
                                                        slotProps={{
                                                            input: {
                                                                readOnly: true
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            } */}

                                        </Grid>
                                    </Grid>
                                    <Grid size={1}>
                                        {
                                            isOpenEditProfilePhoto &&
                                            <DocumentForm isOpen={isOpenEditProfilePhoto} isProfilePhoto={true} loggedUser={homeState.loggedUser}
                                                handleSaveClick={handleProfilePhotoSaveClick}
                                                handleCancelClick={handleProfilePhotoCancelClick}
                                                showAPIError={ShowAPIError} openErrorAlert={OpenErrorAlert} />
                                        }
                                        {
                                            isOpenProfilePhotoDeleteConfirm &&
                                            <ConfirmDialog isOpen={isOpenProfilePhotoDeleteConfirm} title="Confirm Delete"
                                                message="Are you sure you want to delete the profile photo?"
                                                handleClickOK={handleProfilePhotoDeleteConfirmOKClick}
                                                handleClickCancel={handleProfilePhotoDeleteConfirmCancelClick} />
                                        }
                                        {
                                            isOpenNewSalaryPayment &&
                                            <NurseSalaryPaymentForm isOpen={isOpenNewSalaryPayment} handlePageLoadingOpen={handlePageLoadingOpen} handlePageLoadingClose={handlePageLoadingClose}
                                                nurseId={selectedNurseId} handleClose={handleCloseNewSalaryPaymentClick} selectedPayment={selectedNurseSalaryPayment} />
                                        }
                                        {
                                            isOpenAdvancePaymentForm &&
                                            <NurseAdvancePaymentForm isOpen={isOpenAdvancePaymentForm} handlePageLoadingOpen={handlePageLoadingOpen} handlePageLoadingClose={handlePageLoadingClose}
                                                nurseId={selectedNurseId} handleClose={handleCloseAdvancePaymentClick} selectedPayment={selectedAdvancePayment} />
                                        }
                                    </Grid>
                                    <Grid size={3}>

                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            sx={{
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                            }}
                                        >

                                            <Typography variant="h4" color='info'>
                                                {statusText}
                                            </Typography>
                                            <ProfilePhotoCard formMode={formOpenMode}
                                                profilePhotoFile={profilePhotoFile} profilePhotoUrl={profilePhotoUrl}
                                                handleEditClick={handleOpenProfilePhotoEditClick}
                                                handleDeleteClick={handleOpenProfilePhotoDeleteClick} />
                                        </Stack>
                                        {/* <Box sx={{ float: "right" }}>                          
                                           
                                        </Box> */}
                                    </Grid>

                                </Grid>
                            </Box>

                            <Grid container>
                                <Grid size={12}>
                                    <Box sx={{ padding: "16px 0" }}>

                                        <NursePersonalnfo expanded={expanded} isShowValidationMsgs={isShowValidationMsgs}
                                            formOpenMode={formOpenMode}
                                            handleAccordionChange={handleAccordionChange} />

                                        <NurseFamilyView expanded={expanded} formOpenMode={formOpenMode}
                                            handleAccordionChange={handleAccordionChange} />

                                        <NurseContact expanded={expanded} formOpenMode={formOpenMode}
                                            handleAccordionChange={handleAccordionChange} />

                                        <NurseDocumentView expanded={expanded} formOpenMode={formOpenMode}
                                            loggedUser={homeState.loggedUser} showAPIError={ShowAPIError} openErrorAlert={OpenErrorAlert}
                                            handleAccordionChange={handleAccordionChange}
                                        />

                                        {
                                            formOpenMode === FormMode.ViewMode &&
                                            <NurseSalaryPaymentList nurseId={selectedNurseId} expanded={expanded} formOpenMode={formOpenMode}
                                                handlePageLoadingClose={handlePageLoadingClose} handlePageLoadingOpen={handlePageLoadingOpen}
                                                handleAccordionChange={handleAccordionChange} handleEditSalaryPaymentClick={handleOpenNewSalaryPaymentClick}
                                            />
                                        }
                                        {
                                            formOpenMode === FormMode.ViewMode &&
                                            <NurseAdvancePaymentList nurseId={selectedNurseId} expanded={expanded} formOpenMode={formOpenMode}
                                                showAPIError={ShowAPIError} openErrorAlert={OpenErrorAlert} handlePageLoadingClose={handlePageLoadingClose}
                                                handleAccordionChange={handleAccordionChange} handlePageLoadingOpen={handlePageLoadingOpen}
                                                handleEditPayClick={handleOpenAdvancePaymentClick}
                                            />
                                        }
                                        {
                                            formOpenMode === FormMode.ViewMode &&
                                            <NurseVacationList expanded={expanded} formOpenMode={formOpenMode}
                                                nurseId={selectedNurseId} handlePageLoadingClose={handlePageLoadingClose}
                                                handlePageLoadingOpen={handlePageLoadingOpen} handleAccordionChange={handleAccordionChange}
                                            />
                                        }
                                    </Box>
                                </Grid>
                            </Grid>
                        </Stack>
                    </Box>
                </Stack>
            </LocalizationProvider>
        </Box>
    );
}

export default NurseForm;
